import React, { useState, useCallback } from 'react'
import cn from 'classnames'
import { withRouter } from 'react-router-dom'

import styles from './TenderSelect.module.scss'

import { useSelector } from 'react-redux'
import VNConcessionsNavBar from '../../../components/VNConcessionsNavBar'
import useGetIsMobileScreen from '../../../hooks/useGetIsMobileScreen'
import VNBottomButton from '../../../components/VNBottomButton'
import { PAYMENT_TYPES_INTERNAL } from '../../../utils/paymentTypes'
import TenderItem from '../../../VNTenders/components/TenderItem'
import { getGiftCardEnabled, getMobilePaySetting, getTicketEnabled } from '../../../selectors/revenueCenter'
import { MOBILE_PAY_SCAN_QR } from '../../../VNTenders/Utils'
import { VNPPI_TENDERS } from '../../../VNPPI/Enums'
import { getTender } from '../../../VNPPI/Utils'
import { getPpiConfigurations } from '../../../VNPPI/Selectors'
import { ReactComponent as SearchIcon } from '../../../assets/icons/balanceLookupSearchIcon.svg'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { APPLICATION_STRINGS } from '../../../strings'

export const BalanceLookup = ({ className }) => {
  const history = useHistory()
  const isMobileViewPort = useGetIsMobileScreen()

  const push = history?.push ?? (() => {})
  const goBack = history?.goBack ?? (() => {})

  const classNames = cn(styles.tenderSelect, className)

  const [selectedPaymentType, setSelectedPaymentType] = useState('')
  const [paymentsEmpty, setPaymentsEmpty] = useState(false)

  // SELECTORS
  const giftCardEnabled = useSelector(getGiftCardEnabled)
  const mobilePaySetting = useSelector(getMobilePaySetting)
  const ticketEnabled = useSelector(getTicketEnabled)
  const ppiConfigurations = useSelector((state) => getPpiConfigurations(state))

  const ppiTicketTender = getTender(ppiConfigurations, VNPPI_TENDERS.TICKET_TENDER)
  const ppiQRPayTender = getTender(ppiConfigurations, VNPPI_TENDERS.QRPAY_TENDER)
  const ppiGiftcardTender = getTender(ppiConfigurations, VNPPI_TENDERS.GIFTCARD_TENDER)

  const handleNext = () => {
    switch (selectedPaymentType) {
      case PAYMENT_TYPES_INTERNAL.TICKET:
        push({
          pathname: `/ticket`,
          state: {
            fromBalanceLookup: true,
          },
        })
        break

      case PAYMENT_TYPES_INTERNAL.QR_PAY:
        push({
          pathname: `/qr-pay`,
          state: {
            fromBalanceLookup: true,
          },
        })
        break

      case PAYMENT_TYPES_INTERNAL.GIFT_CARD:
        push({
          pathname: `/gift-card`,
          state: {
            fromBalanceLookup: true,
          },
        })
        break

      default:
        return
    }
  }

  const handleTenderSelect = useCallback(
    (paymentType, iconName, managerApproval) => {
      if (paymentType === selectedPaymentType) return
      if (!managerApproval) {
        setSelectedPaymentType(paymentType)
        return
      }
    },
    [selectedPaymentType],
  )

  const isPPIEnabledForTender = (Tender) => {
    const ppiTender = getTender(ppiConfigurations, Tender)

    if (ppiTender?.integration) {
      return true
    }

    return false
  }

  const TenderSelection = useCallback(() => {
    const paymentTypes = []

    if (giftCardEnabled && isPPIEnabledForTender(VNPPI_TENDERS.GIFTCARD_TENDER)) {
      const buttonName = ppiGiftcardTender?.name ? ppiGiftcardTender?.name : 'Gift Card'
      paymentTypes.push([PAYMENT_TYPES_INTERNAL.GIFT_CARD, buttonName])
    }

    if (mobilePaySetting === MOBILE_PAY_SCAN_QR && isPPIEnabledForTender(VNPPI_TENDERS.QRPAY_TENDER)) {
      const buttonName = ppiQRPayTender?.name ? ppiQRPayTender?.name : 'QR Pay'
      paymentTypes.push([PAYMENT_TYPES_INTERNAL.QR_PAY, buttonName])
    }

    if (ticketEnabled && isPPIEnabledForTender(VNPPI_TENDERS.TICKET_TENDER)) {
      const buttonName = ppiTicketTender?.name ? ppiTicketTender?.name : 'Ticket'
      paymentTypes.push([PAYMENT_TYPES_INTERNAL.TICKET, buttonName])
    }

    if (paymentTypes.length === 0) {
      setPaymentsEmpty(true)
      return (
        <div style={{}} className={styles.emptyPaymentContainer}>
          <span className={styles.resourceText}>{APPLICATION_STRINGS.BALANCE_LOOKUP_NO_TENDERS_CONFIGURED}</span>
          <SearchIcon />
        </div>
      )
    }

    return paymentTypes.map(([type, name], idx) => {
      return (
        <TenderItem
          key={`${type}_${idx}`}
          selectedType={selectedPaymentType}
          handleOnClick={() => handleTenderSelect(type, name)}
          {...{ name, type, handleTenderSelect }}
        />
      )
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [giftCardEnabled, handleTenderSelect, mobilePaySetting, selectedPaymentType, ticketEnabled])

  const primaryText = APPLICATION_STRINGS.AVAILABLE_BALANCE_TITLE

  return (
    <div className={classNames}>
      <VNConcessionsNavBar onClick={goBack} textDisplay={isMobileViewPort && primaryText} />
      {!isMobileViewPort && (
        <div className={cn(styles.primaryTextContainer, styles.gratuityPadding)}>
          <span className={styles.primaryText}>{primaryText}</span>
        </div>
      )}
      <div className={styles.tenderSelect__body}>
        <div className={cn([styles.tenderSelections])}>
          <TenderSelection />
        </div>
        <div className={cn(styles.buttonContainer, styles.scanScreen, { [styles.disabled]: paymentsEmpty })}>
          <VNBottomButton text={'Next'} className={styles.buttonNext} onClick={handleNext} disabled={!selectedPaymentType} />
        </div>
      </div>
    </div>
  )
}

export default withRouter(BalanceLookup)
